import styled from "styled-components";
import { getHexOpacity } from "../../../utils/pipes";

export const DataStudio = styled.div`
  background-color: #FFFFFF;
  height: 100%;
  display: flex;
  justify-content: center;
  .frame {
    width: 100%;
  };
`;